import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {uploadRmaDetailExcel} from "../../../../api/support/RMA";
import {useModal} from "../../../../hooks";

export const useUploadRmaDetailExcel = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: FormData) => uploadRmaDetailExcel(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
